"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortDownZero = exports.sorter = void 0;
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var format_1 = require("@/utils/format");
exports.sorter = function (sort, order) {
    return function (a, b) {
        switch (sort) {
            case PlaceState_1.AvailableSortType.SALE_PRICE: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.salePrice > b.salePrice ? 1 : -1;
                }
                return a.salePrice < b.salePrice ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.LEASE_PRICE: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.leasePrice > b.leasePrice ? 1 : -1;
                }
                return a.leasePrice < b.leasePrice ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.NET_SIZE: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.sizeSaleable > b.sizeSaleable ? 1 : -1;
                }
                return a.sizeSaleable < b.sizeSaleable ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.GROSS_SIZE: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.sizeGross > b.sizeGross ? 1 : -1;
                }
                return a.sizeGross < b.sizeGross ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.SALE_PRICE_PER_SQFT: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.salePricePerSqft > b.salePricePerSqft ? 1 : -1;
                }
                return a.salePricePerSqft < b.salePricePerSqft ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.LEASE_PRICE_PER_SQFT: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.leasePricePerSqft > b.leasePricePerSqft ? 1 : -1;
                }
                return a.leasePricePerSqft < b.leasePricePerSqft ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.UPDATE: {
                var aDate = format_1.default.dateStringToDate(a.lastUpdated.toString());
                var bDate = format_1.default.dateStringToDate(b.lastUpdated.toString());
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return aDate > bDate ? 1 : -1;
                }
                return aDate < bDate ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.BED: {
                var aBedField = a.amenities.filter(function (it) { return it.key === 'bed'; });
                var bBedField = b.amenities.filter(function (it) { return it.key === 'bed'; });
                var aBed = aBedField.length ? aBedField[0].value : -1;
                var bBed = bBedField.length ? bBedField[0].value : -1;
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return aBed > bBed ? -1 : 1;
                }
                return aBed < bBed ? -1 : 1;
            }
            case PlaceState_1.AvailableSortType.BATH: {
                var aBathField = a.amenities.filter(function (it) { return it.key === 'bath'; });
                var bBathField = b.amenities.filter(function (it) { return it.key === 'bath'; });
                var aBath = aBathField.length ? aBathField[0].value : -1;
                var bBath = bBathField.length ? bBathField[0].value : -1;
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return aBath > bBath ? -1 : 1;
                }
                return aBath < bBath ? -1 : 1;
            }
            case PlaceState_1.AvailableSortType.NAME: {
                if (order === PlaceState_1.AvailableSortOrder.DESC) {
                    return a.building < b.building ? 1 : -1;
                }
                return a.building > b.building ? 1 : -1;
            }
        }
        return 0;
    };
};
exports.sortDownZero = function (sort) {
    return function (a, b) {
        switch (sort) {
            case PlaceState_1.AvailableSortType.SALE_PRICE: {
                return a.salePrice === 0 || a.salePrice === null ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.LEASE_PRICE: {
                return a.leasePrice === 0 || a.salePrice === null ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.NET_SIZE: {
                return a.sizeSaleable === 0 || a.salePrice === null ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.GROSS_SIZE: {
                return a.sizeGross === 0 || a.salePrice === null ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.SALE_PRICE_PER_SQFT: {
                return a.salePricePerSqft === 0 || a.salePrice === null ? 1 : -1;
            }
            case PlaceState_1.AvailableSortType.LEASE_PRICE_PER_SQFT: {
                return a.leasePricePerSqft === 0 || a.salePrice === null ? 1 : -1;
            }
        }
        return 0;
    };
};
